module.exports = {
	carAccessoriesData: () => {
		return [
			{
				'ESCAPE ECOBOOST': {
					Galeria: [
						{
							Text: 'Cargo cover all weather',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather - EcoBoost',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Placa antideslizante delantera',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de cortinas de aire',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Placa antideslizante trasera',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de puerta',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de arco de rueda',
							Image: require('./../assets/Accesorios/01_Escape_Ecoboost/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'ESCAPE TITANIUM 4X4 FHEV': {
					Galeria: [
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather - HEV',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Placa antideslizante delantera',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de cortinas de aire',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de puerta',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de arco de rueda',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/02_Escape_Hibrida_4x4_Titanium/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'ESCAPE SE 4X2 FHEV': {
					Galeria: [
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather - HEV',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Placa antideslizante delantera',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de cortinas de aire',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de puerta',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de arco de rueda',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/02_Escape_SE_4X2_HEV/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV': {
					Galeria: [
						{
							Text: 'Cargo cover all weather',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguro de espejo',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Placa antideslizante delantera',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de cortinas de aire',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Placa antideslizante trasera',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de puerta',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de molduras de arco de rueda',
							Image: require('./../assets/Accesorios/03_Escape_SEL_4X2_HEV/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'EDGE SEL': {
					Galeria: [
						{
							Text: 'Kit tapetes caucho all weather',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Salpicaderas delanteras',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapete baúl',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera básico',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/07_Edge_SEL/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'EDGE ST': {
					Galeria: [
						{
							Text: 'Kit tapetes caucho all weather',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Enganche de remolque',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Red de carga',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapete baúl',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera básico',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/08_Edge_ST/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'EXPEDITION LIMITED': {
					Galeria: [
						{
							Text: 'Enganche de remolque',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Bola remolque 1 7/8"',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Bola tiro de arrastre 2"',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Enganche de remolque',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera básico',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/12_Expedition_Limited/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'EXPLORER LIMITED': {
					Galeria: [
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes all weather',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tiro de arrastre',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather 2da fila',
							Image: require('./../assets/Accesorios/10_Explorer_Limited/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'EXPLORER ST': {
					Galeria: [
						{
							Text: 'Kit de carretera básico',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather baúl',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes all weather',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather 2da fila',
							Image: require('./../assets/Accesorios/11_Explorer_ST/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'EXPLORER XLT': {
					Galeria: [
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barras de techo',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather baúl',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes all weather',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tiro de arrastre',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather 2da fila',
							Image: require('./../assets/Accesorios/09_Explorer_XLT/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'F-150 LARIAT SPORT': {
					Galeria: [
						{
							Text: 'Cubierta del platón suave 5.5 pies',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Extensión de platón',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra antivuelco negra mate',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de ruedas Fender Flares',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Toma de aire capó',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Sport/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'F-150 XLT FHEV': {
					Galeria: [
						{
							Text: 'Cubierta del platón suave 5.5 pies',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Extensión de platón',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra antivuelco negra mate',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de ruedas Fender Flares',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Toma de aire capó',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'F-150 PLATINUM FHEV': {
					Galeria: [
						{
							Text: 'Cubierta del platón suave 5.5 pies',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Extensión de platón',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra antivuelco negra mate',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de ruedas Fender Flares',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Toma de aire capó',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/22_F150_Lariat_-_Platinum/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'F-150 RAPTOR': {
					Galeria: [
						{
							Text: 'Divisor platón',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Enganche de remolque',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cubierta del platón suave 5.5 pies',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Extensión de platón',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/23_F150_Raptor/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'MUSTANG MACH 1': {
					Galeria: [
						{
							Text: 'Funda vehículo completo',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapete baúl con subwoofer',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de cortinas de aire satín black',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de ventilación capot Satín black',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler trasero coupe',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Aleron de alto perfil para cajuela',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de paneles laterales',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de paneles para ventana',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de faldones laterales',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/13_Mustang_Mach_1/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'MUSTANG GT PREMIUM': {
					Galeria: [
						{
							Text: 'Funda vehículo completo',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapete baúl con subwoofer',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de cortinas de aire Satín black',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de ventilación capó Satín black',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler trasero coupe',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Aleron de alto perfil para cajuela',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de paneles laterales',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de paneles para ventana',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Juego de faldones laterales',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/14_Mustang_GT_Premium/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'RANGER RAPTOR': {
					Galeria: [
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Accesorio capó',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler cabina',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit carretera básico',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra K1 cromada',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Capota lone DC all black',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejo',
							Image: require('./../assets/Accesorios/20_Ranger_Raptor/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'RANGER XL': {
					Galeria: [
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/16_Ranger_XL/01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/16_Ranger_XL/02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/16_Ranger_XL/03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/16_Ranger_XL/04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/16_Ranger_XL/05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/16_Ranger_XL/06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra K1 cromada',
							Image: require('./../assets/Accesorios/16_Ranger_XL/07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra K1 negra',
							Image: require('./../assets/Accesorios/16_Ranger_XL/08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces DRL',
							Image: require('./../assets/Accesorios/16_Ranger_XL/09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfiles superiores laterales',
							Image: require('./../assets/Accesorios/16_Ranger_XL/10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfil superior compuerta',
							Image: require('./../assets/Accesorios/16_Ranger_XL/11.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Bedliner con perfil superior',
							Image: require('./../assets/Accesorios/16_Ranger_XL/12.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/16_Ranger_XL/13.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Capota lona flex',
							Image: require('./../assets/Accesorios/16_Ranger_XL/14.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Estribos tubulares cromados',
							Image: require('./../assets/Accesorios/16_Ranger_XL/15.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tiro de arrastre',
							Image: require('./../assets/Accesorios/16_Ranger_XL/16.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/16_Ranger_XL/17.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguro llanta de repuesto',
							Image: require('./../assets/Accesorios/16_Ranger_XL/18.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'RANGER XLS DIESEL': {
					Galeria: [
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra K1 cromada',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Estribos tubulares cromados',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Estribos tubulares negros',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tiro de arrastre',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguro llanta de repuesto',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfiles superiores laterales',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_11.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Barra K1 negra',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_12.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_13.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_14.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_15.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfil superior compuerta',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_16.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Bedliner con perfil superior',
							Image: require('./../assets/Accesorios/17_Ranger_XLS_Diesel/Accesorio_17.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'BRONCO SPORT WILDTRAK': {
					Galeria: [
						{
							Text: 'Barras de techo WildTrak',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Ensamble de tiro de arrastre',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Toma de aire capó',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de techo',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de ruegas Fender Flares',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather WildTrak',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/05_Bronco_WT/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'BRONCO SPORT BIG BEND': {
					Galeria: [
						{
							Text: 'Barras de techo Bing Bend',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Ensamble de tiro de arrastre',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Toma de aire capó',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de techo',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de ruegas Fender Flares',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather Bing Bend',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'BRONCO SPORT OUTER BANKS': {
					Galeria: [
						{
							Text: 'Barras de techo Bing Bend',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Ensamble de tiro de arrastre',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tapetes de caucho all weather',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Toma de aire capó',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de techo',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura de puertas',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de ruegas Fender Flares',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Cargo cover all weather Bing Bend',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},

				'RANGER FX4': {
					Galeria: [
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Capota lona flex',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces DRL',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfiles superiores laterales',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfil superior compuerta',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Bedliner sin perfil superior',
							Image: require('./../assets/Accesorios/24_Ranger_Fx4/10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},
				'RANGER LIMITED': {
					Galeria: [
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Capota lona barra fibra',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces DRL',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfiles superiores laterales',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfil superior compuerta',
							Image: require('./../assets/Accesorios/19_Ranger_Limited/10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},
				'RANGER LIMITED BLACK EDITION': {
					Galeria: [
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Capota lona flex',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces DRL',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfiles superiores laterales',
							Image: require('./../assets/Accesorios/26_Ranger_Limited_Black_Edition/09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/06_Bronco_BB/Accesorio_10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},
				'RANGER XL CHASIS': {
					Galeria: [
						{
							Text: 'Kit de carretera básico',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera intermedio',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit de carretera alta gama',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces DRL',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/15_Ranger_XL_Chasis/Accesorio_07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},
				'RANGER XLT': {
					Galeria: [
						{
							Text: 'Molduras capó',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/01.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/02.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Moldura compuerta trasera',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/03.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler compuerta trasera',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/04.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Kit extensiones de rueda fender flares',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/05.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Spoiler de cabina',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/06.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Capota lona flex',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/07.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Protector de bumper con luces DRL',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/08.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfiles superiores laterales',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/09.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Perfil superior compuerta',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/10.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Bedliner sin perfil superior',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/11.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Pernos de seguridad',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/12.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Paneles puerta',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/13.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Tiro de arrastre',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/14.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros de espejos',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/15.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
						{
							Text: 'Seguros llanta de repuesto',
							Image: require('./../assets/Accesorios/18_Ranger_XLT/16.webp'),
							URL: 'https://www.ford.com.co/posventa/accesorios/',
						},
					],
				},
			},
		];
	},
};
